export const USER_ROLES = {
    SUPER_ADMIN:0,
    ADMIN: 1,
    BASIC: 2
}